import configurations from "./configurations";
import exportInfo from "./exportInfo";
import exportRuns from "./exportRuns";
import geonames from "./geonames";
import nominatim from "./nominatim";
import hdx from "./hdx";
import importGeom from "./importGeom";
import jobs from "./jobs";
import overpassLastUpdated from "./overpassLastUpdated";
import galaxyLastUpdated from "./galaxyLastUpdated";
import meta from "./meta";
import mode from "./mode";
import showImportModal from "./showImportModal";
import status from "./status";
import toolbarIcons from "./toolbarIcons";
import partners from "./partners";
import stats from "./stats";

export default {
  configurations,
  exportInfo,
  exportRuns,
  geonames,
  hdx,
  importGeom,
  jobs,
  meta,
  mode,
  overpassLastUpdated,
  galaxyLastUpdated,
  showImportModal,
  status,
  toolbarIcons,
  partners,
  stats,
  nominatim
};



// WEBPACK FOOTER //
// ./app/reducers/index.js